import { API } from '@/redux/config';
import {
  setToolFields,
  setAllAlertingToolPolicies,
  setAllAlertingTools,
  setToolMappingData,
  setToolProjectsData,
  getAllToolInfo,
  setReducerError,
  start,
  setCompanyServicesList,
  setToggleModal,
  setCustomerToolMappingData,
} from '../reducers/alertReducer';
import { raiseErrorException } from '../../utils/raiseErrorException';

//* Get Alerting Tools
export const getAllAlertingTools = () => async (dispatch) => {
  try {
    dispatch(start());
    const response = await API.get(`/alerting_tools/tool`);
    dispatch(setAllAlertingTools(response?.data));
  } catch (err) {
    console.log(err);
    raiseErrorException(err, dispatch, setReducerError, 'get');
  }
};
//* Get Alerts company service list
export const getAllCompanyServiceLists = () => async (dispatch) => {
  try {
    dispatch(start());
    const response = await API.get(`/alerting_tools/enable/customer?all=true`);
    dispatch(setCompanyServicesList(response?.data));
  } catch (err) {
    raiseErrorException(err, dispatch, setReducerError, 'get');
  }
};
//* create Alerting Tools
export const createAlertingTools = (data, toggle) => async (dispatch) => {
  try {
    dispatch(start());
    const response = await API.post(`/alerting_tools/tool`, data);
    dispatch(getAllAlertingTools());
    toggle();
  } catch (err) {
    raiseErrorException(err, dispatch, setReducerError);
  }
};
//* get Tool MApping
export const getToolMappingData = (customerID) => async (dispatch) => {
  try {
    dispatch(start());
    const response = await API.get(`/alerting_tools/tool_mapping?filterCustomer=true`);
    dispatch(setToolMappingData(response?.data));
  } catch (err) {
    raiseErrorException(err, dispatch, setReducerError, 'get');
  }
};
//* create Tool Mapping
export const createToolMapping = (data, toggle) => async (dispatch) => {
  try {
    dispatch(start());
    const response = await API.post(`/alerting_tools/tool_mapping`, data);
    dispatch(getAllAlertingTools());
    toggle();
  } catch (err) {
    raiseErrorException(err, dispatch, setReducerError);
  }
};
export const createCustomerToolMapping = (data, toggle) => async (dispatch) => {
  try {
    dispatch(start());
    const response = await API.post(`/alerting_tools/__`, data);
    dispatch(getAllAlertingTools());
    toggle();
  } catch (err) {
    raiseErrorException(err, dispatch, setReducerError, 'get');
  }
};
//* update Tool Mapping
export const updateToolMapping = (toolMappingID, customerID, data, toggle) => async (dispatch) => {
  try {
    dispatch(start());
    const response = await API.put(`/alerting_tools/tool_mapping/${toolMappingID}`, data);
    dispatch(getToolMappingData(customerID));
    toggle();
  } catch (err) {
    raiseErrorException(err, dispatch, setReducerError);
  }
};
//* delete Tool Mapping
export const deleteToolMapping = (toolMappingID, customerID, toggle) => async (dispatch) => {
  try {
    dispatch(start());
    const response = await API.delete(`/alerting_tools/tool_mapping/${toolMappingID}`);
    dispatch(getToolMappingData(customerID));
    toggle();
  } catch (err) {
    raiseErrorException(err, dispatch, setReducerError);
  }
};

//* get Tool Projects
export const getToolProjectsData = (customerID) => async (dispatch) => {
  try {
    dispatch(start());
    const response = await API.get(`/alerting_tools/project?filterCustomer=true`);
    dispatch(setToolProjectsData(response?.data));
  } catch (err) {
    raiseErrorException(err, dispatch, setReducerError, 'get');
  }
};
//* create Tool Project
export const createToolProject = (data, toggle) => async (dispatch) => {
  try {
    dispatch(start());
    const response = await API.post(`/alerting_tools/project`, data);
    dispatch(getAllAlertingTools());
    toggle();
  } catch (err) {
    raiseErrorException(err, dispatch, setReducerError);
  }
};
export const createCustomerToolProject = (data, toggle) => async (dispatch) => {
  try {
    dispatch(start());
    const response = await API.post(`/alerting_tools/__`, data);
    dispatch(getAllAlertingTools());
    toggle();
  } catch (err) {
    raiseErrorException(err, dispatch, setReducerError);
  }
};
//* update Tool Project
export const updateToolProject = (data, toggle) => async (dispatch) => {
  try {
    dispatch(start());
    const response = await API.put(`/alerting_tools/project`, data);
    dispatch(getToolProjectsData(data?.customerID));
    toggle();
  } catch (err) {
    raiseErrorException(err, dispatch, setReducerError);
  }
};
//* delete Tool Project
export const deleteToolProject = (data, toggle) => async (dispatch) => {
  try {
    dispatch(start());
    const response = await API.delete(`/alerting_tools/project`, { data });
    dispatch(getToolProjectsData(data?.customerID));
    toggle();
  } catch (err) {
    raiseErrorException(err, dispatch, setReducerError);
  }
};

//* Get Alerting Tool Policies
export const getAllAlertingToolPolicies = (customerID) => async (dispatch) => {
  try {
    dispatch(start());
    const response = await API.get(`/alerting_tools/tool_policy/customer`);
    dispatch(setAllAlertingToolPolicies(response?.data));
  } catch (err) {
    raiseErrorException(err, dispatch, setReducerError, 'get');
  }
};
//* create alert policy
export const createAlertPolicy = (data, types, toggle, customerID) => async (dispatch) => {
  try {
    dispatch(start());
    const response = await API.post(`/alerting_tools/tool_policy`, data);
    const policyID = response?.data?.policyID;
    types?.map((type) => dispatch(createAlertPolicyNotification(policyID, type)));
    dispatch(getAllAlertingToolPolicies(customerID));
    toggle();
  } catch (err) {
    raiseErrorException(err, dispatch, setReducerError);
  }
};
//* update alert policy
export const updateAlertPolicy = (data, addTypes, removeTypes, policyID, customerID, toggle) => async (dispatch) => {
  try {
    dispatch(start());
    const response = await API.put(`/alerting_tools/tool_policy/${policyID}`, data);
    addTypes?.map((type) => dispatch(createAlertPolicyNotification(policyID, type)));
    removeTypes?.map((type) => dispatch(deleteAlertPolicyNotification(policyID, type?.id)));
    dispatch(getAllAlertingToolPolicies(customerID));
    toggle();
  } catch (err) {
    raiseErrorException(err, dispatch, setReducerError);
  }
};
//* delete alert policy
export const deleteAlertPolicy = (policyID, customerID) => async (dispatch) => {
  try {
    dispatch(start());
    const response = await API.delete(`/alerting_tools/tool_policy/${policyID}`);
    dispatch(getAllAlertingToolPolicies(customerID));
  } catch (err) {
    raiseErrorException(err, dispatch, setReducerError);
  }
};

//* create alert policy notification
export const createAlertPolicyNotification = (policyID, notificationType) => async (dispatch) => {
  try {
    dispatch(start());
    const response = await API.post(`/alerting_tools/tool_policy/notification`, { policyID, notificationType });
  } catch (err) {
    raiseErrorException(err, dispatch, setReducerError);
  }
};
//* delete alert policy notification
export const deleteAlertPolicyNotification = (policyID, notificationID) => async (dispatch) => {
  try {
    dispatch(start());
    const response = await API.delete(`/alerting_tools/tool_policy/${policyID}/notification/${notificationID}`);
  } catch (err) {
    raiseErrorException(err, dispatch, setReducerError);
  }
};

//* show tool info
export const showToolInformation = (customerID, toolID) => async (dispatch) => {
  try {
    dispatch(start());
    const response = await API.get(`alerting_tools/tool_mapping?customerID=${customerID}&toolID=${toolID}`);
    dispatch(getAllToolInfo(response?.data));
  } catch (err) {
    raiseErrorException(err, dispatch, setReducerError, 'get');
  }
};
//* get tool fields
export const getToolFields = (toolName) => async (dispatch) => {
  try {
    // dispatch(start());
    const response = await API.get(`/${toolName}/fields`);
    dispatch(setToolFields(response?.data));
  } catch (err) {
    const errorResult = raiseErrorException(err, dispatch, setReducerError, 'get');

    if (errorResult.status === 404) {
      dispatch(setToolFields(null));
    }
  }
};

//* test connection
export const testToolConnection = (toolName, data) => async (dispatch) => {
  try {
    const response = await API.post(`/${toolName}/test_connection`, data);
    return response?.data;
  } catch (err) {
    const errorResult = raiseErrorException(err, dispatch, setReducerError);
    return { error: true, message: errorResult.message, status: errorResult.status };
  }
};

export const toggleAlertModal = () => async (dispatch) => dispatch(setToggleModal());

export const getCustomerToolMappingData = () => async (dispatch) => {
  try {
    dispatch(start());
    const response = await API.get(`/sentinelone/instance`);
    dispatch(setCustomerToolMappingData(response?.data));
  } catch (err) {
    raiseErrorException(err, dispatch, setReducerError, 'get');
  }
};
//* add customer tool mapping
export const addCustomerToolMapping = (data, toggle) => async (dispatch) => {
  try {
    dispatch(start());
    const response = await API.post(`/sentinelone/instance`, data);
    dispatch(getCustomerToolMappingData());
    toggle();
  } catch (err) {
    raiseErrorException(err, dispatch, setReducerError);
  }
};
//* delete customer tool mapping
export const deleteCustomerToolMapping = (id) => async (dispatch) => {
  try {
    dispatch(start());
    const response = await API.delete(`/sentinelone/instance/${id}`);
    dispatch(getCustomerToolMappingData());
  } catch (err) {
    raiseErrorException(err, dispatch, setReducerError);
  }
};

//* update customer tool mapping
export const updateCustomerToolMapping = (id, data) => async (dispatch) => {
  try {
    dispatch(start());
    const response = await API.put(`/sentinelone/instance/${id}`, data);
    dispatch(getCustomerToolMappingData());
  } catch (err) {
    raiseErrorException(err, dispatch, setReducerError);
  }
};

//* test customer tool connection
export const testCustomerToolConnection = (data) => async (dispatch) => {
  try {
    const response = await API.post(`/sentinelone/instance/test_connection`, data);
    return response?.data;
  } catch (err) {
    const errorResult = raiseErrorException(err, dispatch, setReducerError);
    return { error: true, message: errorResult.message, status: errorResult.status };
  }
};
